import FusionClass from './core/bridge'

export default FusionClass
